<script setup>
import {useDataTable} from "@/lib/useDataTable";
import {ref} from "vue"
import {useRouter} from "vue-router/composables";
import helpers from "@/lib/helpers";
import store from "@/store";

const router = useRouter()

const modal_ref = ref(null)

const props = defineProps({
  url: String
})

const params = ref({filter: 'focused'})
const {
  tableProps,
  tableData,
  tableRecords,
  tableRefresh
} = useDataTable('notification', '/api/user/self/notification', params.value, 25);

const closing = () => {
  store.dispatch('badges_load')
  return true
}

const ack = async (n) => {
  await helpers.asyncAction(n._links.ack_url.href, n._links.ack_url.method, {
    data: {
      platform: 'oms',
    }
  })
}

const unack = async (n) => {
  await helpers.asyncAction(n._links.unack_url.href, n._links.unack_url.method)
  tableRefresh()
}
const click = (n) => {
  modal_ref.value.close()
  ack(n)

  if (n.data.route)
    router.push(n.data.route)
  else if (n.data.report)
    router.push({name: 'report-select'})
  else
    helpers.global_lookup(n.data.gli)
}

</script>

<template>
  <modal
      title="Notifications"
      large
      :onClose="closing"
      ref="modal_ref"
      height="400px"
  >
    <template #top>
      <chip-selector class="mb-0" v-model="params.filter"
                     :items="[
                         {text: 'Focused', value: 'focused'},
                         {text: 'General', value: 'general'},
                         {text: 'Acknowledged', value: 'ack'}
                         ]"/>
    </template>

    <template #footer>
      <b-pagination
          v-if="tableRecords > 0"
          v-model="tableData.currentPage"
          class="my-0 justify-content-center align-items-center"
          :total-rows="tableRecords"
          :per-page="tableData.perPage"
      />
    </template>

    <div class="m-2">
      <b-list-group>
        <b-list-group-item v-for="n in tableProps.items" :key="n.id" class="d-flex flex-row cursor-pointer"
                           @click="click(n)">
          <div class="my-auto mr-3">
            <font-awesome-icon style="width: 15px;" v-if="!n.ack" :icon="['fas', 'circle']" class="text-warning"/>
            <div v-else style="width: 15px"/>
          </div>
          <div class="flex-column align-items-start flex-fill">
            <div class="d-flex w-100 justify-content-between">
              <div class="font-weight-bold mb-1">{{ n.title }}</div>
              <small>{{ n.created | timediff }}</small>
            </div>
            <div>{{ n.body }}</div>
            <small v-if="n.acks && n.acks.length">Acknowledged at {{ n.acks[0].created | date }} on
              {{ n.acks[0].platform }}</small>
          </div>
          <div class="my-auto ml-3" v-if="n.ack && n.focused">
            <b-button @click.stop="unack(n)" variant="link" size="sm" class="text-warning">
              <font-awesome-icon :icon="['fas', 'rotate-left']"/>
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </div>
  </modal>
</template>


<style scoped>

</style>